import { PropsWithChildren, useRef } from "react";

import { InferenceFormContext } from "./context";
import { InferenceFormsInitializer } from "./InferenceFormsInitializer";
import { InferenceFormStore, inferenceFormStore } from "./store";

export const InferenceFormState = (props: PropsWithChildren) => {
  const { children } = props;

  const storeRef = useRef<InferenceFormStore>(inferenceFormStore());

  return (
    <InferenceFormContext.Provider value={storeRef.current}>
      <InferenceFormsInitializer />
      {children}
    </InferenceFormContext.Provider>
  );
};
